<template>
  <Layout>
    <div class="container">
      <transition name="fade">
        <div v-if="showLoaderOverlay"
             class="fixed inset-0 flex items-center justify-center z-30 bg-onvocado-white bg-opacity-75">
          <Loader></Loader>
        </div>
      </transition>
      <h1 class="has-subheading">Choose the plan that works for you</h1>
      <p>All plans can be canceled any time.</p>

      <plans-preview-component
          :default-currency="defaultCurrency"
          @subscription-change="triggerChangeSubscriptionModal"/>

      <stripe-checkout v-if="sessionId" ref="checkout" :session-id="sessionId"/>

<!--      <transition name="fade">-->
<!--        <subscription-payment-component-->
<!--            v-if="subscriptionPaymentComponentVisible"-->
<!--            @close="subscriptionPaymentComponentVisible = false"/>-->
<!--      </transition>-->
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main.vue'
import { mapActions } from 'vuex'
import PlansPreview from '@components/Payment/PlansPreview/PlansPreview.vue'
import StripeCheckout from '@components/Payment/StripeCheckout/StripeCheckout.vue'
import appConfig from '@src/app.config.json'
// import SubscriptionPaymentForm from '@components/forms/SubscriptionPaymentForm.vue'

export default {
  page: {
    title: 'Billing',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  name: 'BillingView',
  components: {
    Layout,
    'plans-preview-component': PlansPreview,
    // 'subscription-payment-component': SubscriptionPaymentForm,
    'stripe-checkout': StripeCheckout,
  },
  data() {
    return {
      // subscriptionPaymentComponentVisible: false,
      sessionId: null,
      showLoaderOverlay: false,
    }
  },
  computed: {
    defaultCurrency() {
      return this.$store.getters['users/defaultCurrency']
    },
  },
  mounted() {
    // if (typeof window.paypal === 'undefined') {
    //   const paypalObjects = document.createElement('script')
    //   paypalObjects.setAttribute(
    //       'src',
    //       'https://www.paypalobjects.com/api/checkout.js',
    //   )
    //   paypalObjects.setAttribute('data-version-4', '')
    //   paypalObjects.setAttribute('data-log-level', 'info')
    //   document.head.appendChild(paypalObjects)
    // }
  },
  methods: {
    ...mapActions('subscription', [
      'setChosenSubscriptionID',
      'generateCheckoutSession',
    ]),
    triggerChangeSubscriptionModal(planID) {
      this.setChosenSubscriptionID(planID)
      this.showLoaderOverlay = true
      // Creating a new Session each time your customer attempts to pay.
      const payload = {
        plan_id: planID,
        success_url: process.env.VUE_APP_SUCCESS_URL,
        cancel_url: process.env.VUE_APP_CANCEL_URL,
      }

      this.generateCheckoutSession(payload).then((data) => {
        this.sessionId = data.sessionId
      })

      // if (planID) {
      //   this.setChosenSubscriptionID(planID)
      //   this.subscriptionPaymentComponentVisible = true
      // }
    },
  },
}
</script>